module.exports = __webpack_public_path__ + "static/media/moons_comer_brackets-960.ac018f06.webp";